import reducer from './reducer'

import * as entityProfilesOperations from './operations'
import * as entityProfilesSelectors from './selectors'

export { entityProfilesOperations, entityProfilesSelectors }

export default reducer
